import { GdsServiceFragment } from '@websky/graphql';
import { getTravellers } from '../Checkout/store/order/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useIsCanModifyServices = (services: GdsServiceFragment[]) => {
	const travellers = useSelector(getTravellers);

	return useMemo(
		() =>
			services.some(service => {
				const canBeRemoved = service.allowedPassengers.some(ids =>
					ids.some(passengerId => {
						const passengerServices = travellers.find(traveller => traveller.id === passengerId)?.services;

						if (passengerServices) {
							const gdsService = passengerServices.gdsServices?.services?.find(
								srv => srv.serviceId === service.id
							);

							if (gdsService) {
								return gdsService.count > gdsService.confirmedCount;
							}

							const brandIncludedService = passengerServices.brandIncludedServices?.services?.find(
								srv => srv.serviceId === service.id
							);

							if (brandIncludedService) {
								return brandIncludedService.count > brandIncludedService.confirmedCount;
							}
						}

						return false;
					})
				);

				return canBeRemoved || service.canBeAdded;
			}),
		[services, travellers]
	);
};
